module.exports = __webpack_public_path__ + "static/media/10_pol_0_91.67.8049a900.png";